import { useEffect, useState } from "react";
import {
  detectUserCountry, currencyForCountry, fetchFxRates,
  convertFromUSD, formatAmount,
} from "../utils/currency";

// Hook que detecta el país del visitante y devuelve helper para mostrar
// precios USD convertidos a moneda local. Falla en silencio: si las APIs
// externas no responden, devuelve { currency: "USD", convert: () => null }.
export function useUserCurrency() {
  const [currency, setCurrency] = useState("USD");
  const [rates, setRates] = useState(null);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      const country = await detectUserCountry();
      const userCurrency = country ? currencyForCountry(country) : "USD";
      const fxRates = userCurrency !== "USD" ? await fetchFxRates() : null;
      if (cancelled) return;
      setCurrency(userCurrency);
      setRates(fxRates);
      setReady(true);
    })();
    return () => { cancelled = true; };
  }, []);

  return {
    currency,
    ready,
    convertFromUSD: (amountUSD) => convertFromUSD(amountUSD, currency, rates),
    formatLocal: (amountUSD) => {
      if (currency === "USD") return null;
      const converted = convertFromUSD(amountUSD, currency, rates);
      return converted != null ? formatAmount(converted, currency) : null;
    },
  };
}
